import Panel from './Panel';

export { PanelContent } from './components';

export default Panel;
